<template>
  <div>
  <b-navbar toggleable="lg" type="dark" class="banner" variant="infoX">
    <!-- <b-navbar-brand href="#">NavBar</b-navbar-brand> -->
		<v-flex class="study-header" xs7 row>
              <img
                class="logo_brand mr-2"
                src="../assets/NSF_Logo_flat.png"
                width="25px"
                height="25px"
                alt="NSF Logo"
              />
            <div class="banner-text-row1-bold appendYearVol">NSF Survey of Federal Funds for Research and Development:</div>
          </v-flex>

    <b-collapse id="nav-collapse" is-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">

        <b-nav-item href="#" @click="adminlanding">Home</b-nav-item>

        <b-nav-item-dropdown text="Collection" right>
          <b-dropdown-item href="#" @click="allstats">All Office Data Collection Status</b-dropdown-item>
          <b-dropdown-item href="#" @click="adminlanding">Data Collection Status</b-dropdown-item>
					<b-dropdown-item href="#" @click="adminprogress">Progress Monitor</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown text="Search" right>
          <b-dropdown-item href="#" @click="officesearch">Offices</b-dropdown-item>
          <b-dropdown-item href="#" @click="peoplesearch">People</b-dropdown-item>
          <b-dropdown-item href="#" @click="codebooksearch">Org List</b-dropdown-item>
        </b-nav-item-dropdown>
				<b-nav-item-dropdown text="Support" right>
					<b-dropdown-item href="#" @click="supportRequest">Create or View Support Request</b-dropdown-item>
					<b-dropdown-item href="#" @click="supportRequestSummary">View Support Summary Stats</b-dropdown-item>
          <b-dropdown-item href="#" @click="addNewOffice">Add New Offices with New Agencies</b-dropdown-item>
					<b-dropdown-item href="#" @click="manageOffices">Manage Offices</b-dropdown-item>
				</b-nav-item-dropdown>
        <b-nav-item-dropdown text="Logout" right>
          <b-dropdown-item href="#" @click="logout">Logout</b-dropdown-item>
          <b-dropdown-item href="#" @click="change">Change Password</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</div>
</template>

<script>
import Vue from "vue";
import { authTokenService } from "@/services/authTokenService.js";
import { authService } from "@/services/authService.js";
import { CONSTANTS } from "../common/constants";
import router from "@/router";
import { officeManagementService } from "@/services/officeManagementService.js";
import { adminService } from "@/services/adminService.js";

export default {
  name: "NavBarAdmin",
  components: {},
  data: () => ({
    officeDescription: '',
    reportId: null,
    reportsData: [],
	}),
  methods: {
    logout () {
      authService.logout();
    },
    change () {
      router.push({ name: 'changepassword' });
		},
    adminlanding () {
      router.push({ path: "/admin" });
    },
    adminprogress () {
      router.push({ name: "admin.progress" });
    },
    allstats () {
      router.push({ name: "admin.allstats" });
    },
    officesearch () {
      router.push({ name: "admin.search.office" });
    },
    codebooksearch () {
      router.push({ name: "admin.search.codebook" });
    },
    reports () {
      router.push({ name: "admin.reports" });
    },
    report(id) {
      this.reportId = id;
      switch(this.reportId)
      {
        case 1:{
          router.push({
            name: "admin.reportdetails",
            params: { reportId:this.reportId  }
          }).catch(err => {});
          break;
        }
        case 2:{
          router.push({
            name: "admin.reportNatPat",
            params: { reportId:this.reportId  }
          }).catch(err => {});
          break;
        }
      }
    },
    peoplesearch () {
      router.push({ name: "admin.search.people" });
    },
    support () {
      router.push({ name: "admin.support" });
		},
		supportRequest () {
			router.push({ name: "admin.supportRequest" });
		},
		supportRequestSummary () {
			router.push({ name: "admin.supportRequestSummary" });
		},
		addNewOffice () {
			router.push({ name: "admin.addnewoffice" });
		},
    manageOffices () {
			router.push({ name: "admin.manageoffices" });
		}
  },
  mounted () {
    const me = this;
		const claims = authTokenService.getClaims();
		const activeId = authTokenService.getActiveSurveyId();

    if (activeId) {
      officeManagementService.getOfficeBySurveyId(activeId).then(function (response) {
        if (response && response.data)
        {
          me.officeDescription = response.data.description;
        }
      });
    } else {
      me.officeDescription = 'Admin';
    }

    adminService
    .getReports()
    .then(function(resp) {
      var tmpColumnDef = {};
      me.reportsData = resp.data.records;
      //console.log('me.reportsData = ' + JSON.stringify(me.reportsData));
    })
    .catch(function(err) {
      console.error(err);
    });

	}
};
</script>

<style scoped>
.banner  {
  margin: 0;
  padding: 0;
  padding-left: 10px;
  padding-right: 10px;
  background-color: #0f5182;
  /* flex-direction: column; */
  /* align-items: stretch; */
  box-shadow: 0 0 5px grey;
  font-family: Calibri(body), Cambria, Cochin, Georgia, Times, serif;
  color: white;
}
.row1 {
  align-items: center;
}
.banner-text-row1-bold {
  /* font-size: 13pt; */
  font-weight: bold;
}
.banner-text-row1 {
  font-size: 11pt;
  font-weight: normal;
}
.study-header {
  justify-content: flex-start;
  margin-left: 10px;
  align-items: center;
}

.navbar-dark .navbar-nav .nav-link {
  /* color: #e5ffff !important; */
  color: white !important;
}

.navbar-dark .navbar-nav .nav-link:hover {
  text-decoration: underline;
}

a {
  display: block;
}

::v-deep .dropdown .nav-link {
   color: white !important;
}

::v-deep .dropdown .nav-link {
   color: white !important;
}

</style>
